export const SHIFT_STATUS = {
  OPEN: "open",
  OFFERED: "offered",
  REQUESTED: "requested",
  ASSIGNED: "assigned",
  ACTIVATED: "activated",
  ARRIVED: "arrived",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  EXPIRED: "expired",
};

export const ACTIVE_SHIFT_STATUSES = [
  SHIFT_STATUS.OPEN,
  SHIFT_STATUS.OFFERED,
  SHIFT_STATUS.REQUESTED,
  SHIFT_STATUS.ASSIGNED,
  SHIFT_STATUS.ACTIVATED,
  SHIFT_STATUS.ARRIVED,
];

export const CLOSED_SHIFT_STATUSES = [
  SHIFT_STATUS.COMPLETED,
  SHIFT_STATUS.CANCELLED,
  SHIFT_STATUS.EXPIRED,
];

export const BILLABLE_SHIFT_STATUSES = [
  SHIFT_STATUS.COMPLETED,
];

export const PAYABLE_SHIFT_STATUSES = [
  SHIFT_STATUS.COMPLETED,
];

export function isActiveShift(status) {
  return ACTIVE_SHIFT_STATUSES.includes(String(status || "").toLowerCase());
}

export function isClosedShift(status) {
  return CLOSED_SHIFT_STATUSES.includes(String(status || "").toLowerCase());
}

export function isBillableShift(status) {
  return BILLABLE_SHIFT_STATUSES.includes(String(status || "").toLowerCase());
}

export function isPayableShift(status) {
  return PAYABLE_SHIFT_STATUSES.includes(String(status || "").toLowerCase());
}